var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M617.1 671.2H148.2c-46.3 0-83.9-37.6-83.9-83.9v-307c0-46.3 37.6-83.9 83.9-83.9h468.9c46.3 0 83.9 37.6 83.9 83.9v306.9c0 46.4-37.5 84-83.9 84z",
    fill: "#248CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3 302.3h636.8v96.1H64.3z",
    fill: "#183351"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304 531.8H128.3c-12.1 0-22-9.9-22-22s9.9-22 22-22H304c12.1 0 22 9.9 22 22s-9.9 22-22 22zM437.4 601.2H128.3c-12.1 0-22-9.9-22-22s9.9-22 22-22h309.1c12.1 0 22 9.9 22 22s-9.9 22-22 22z",
    fill: "#FBFAEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M875.8 827.6H406.9c-46.3 0-83.9-37.6-83.9-83.9v-307c0-46.3 37.6-83.9 83.9-83.9h468.9c46.3 0 83.9 37.6 83.9 83.9v306.9c0 46.4-37.5 84-83.9 84z",
    fill: "#F5DB6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M788.3 607.2H387c-12.1 0-22-9.9-22-22s9.9-22 22-22h401.3c12.1 0 22 9.9 22 22s-9.9 22-22 22z",
    fill: "#AEB8C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M562.7 688.2H387c-12.1 0-22-9.9-22-22s9.9-22 22-22h175.8c12.1 0 22 9.9 22 22-0.1 12.1-10 22-22.1 22zM696.1 757.6H387c-12.1 0-22-9.9-22-22s9.9-22 22-22h309.1c12.1 0 22 9.9 22 22s-9.9 22-22 22z",
    fill: "#FBFAEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 520.3H401.8c-20.3 0-36.8-16.5-36.8-36.8v-50.8c0-20.3 16.5-36.8 36.8-36.8h108.6c20.3 0 36.8 16.5 36.8 36.8v50.8c0 20.3-16.5 36.8-36.8 36.8z",
    fill: "#F3C262"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M547.2 438.1h-34.3v-42.2H479v124.4h33.9v-47.7h34.3zM402.6 395.9v42.2H365v34.5h37.6v47.7h33.9V395.9z",
    fill: "#F7A04D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M959.7 577.8V484c-80.6-0.3-148.2-56.4-166.1-131.6h-95.5c19.2 127.2 129.2 225.1 261.6 225.4z",
    fill: "#F7F9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardIcon);
export default __webpack_public_path__ + "static/media/bank-card-icon.ae1186e75dd0a79d6a38da294f92c17e.svg";
export { ForwardRef as ReactComponent };